import { SAVE_SEARCH_INSTANCES } from 'app-constants';
import { apiServer } from 'settings/web-services/api';

export function saveSearchInstance(cfg) {
  return apiServer.post(SAVE_SEARCH_INSTANCES, cfg);
}
